import * as React from "react";
import { withTranslation } from "react-i18next";
import { StyledModal } from "./StyledModal";
import {
  Period,
  ProjectInvoice
} from "../../pages/KickbackProjectReportPage";
import i18n from "../../i18n";

import Datalist, { ListColumn } from "../Datalist/Datalist";
import StyledAccordion from "../Accordion/StyledAccordion";
import { Button, Col, Form, FormGroup, Row, Spinner, Stack } from "react-bootstrap";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { DataService } from "../../services/DataService";
import { InvoiceData } from "../../services/API/Invoices";
import { FieldProperty, InvoiceFields } from "../../services/API/InvoiceReports";
import { IsUserSinfra, ReadFriendlyNumber } from "../../lib/utils";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export type ProjectReport = {
  id:number;
  reportId: string;
  contractId: string;
  projectName: string;
  invoiceReference: string;
  invoiceIdentifier: string;
  kickbackSum:number;
  sumExclMoms: number;
  comment: string;
  period: string;
  reportDate: Date;
  reporter: string;
  supplierOrgId: string;
  status: number;
  projectEndDate: Date | string | null;
  customerId:string;
  //kick:number;
};
type CheckBox = {
  [key: string]: boolean;
};
export type StatusObj = {
  errors:number;
  warnings:number;
  duplicates:number;
  totalSum:number;
  totalRows:number;
  comment:string;
}
type Comment = {
  [contractId:string]:string;
}
interface SubmitKickbackProjectProps {
  submitHandler: (period: string, status: number, message: string,data?:any) => void;
  closeModal: () => void;
  //data: PeriodPerContract;
  data: Period;
  
  //data: any;
  period: string;
  onClickDataCard(key:"warnings"|"duplicates"|"errors"):void;
}
interface SubmitKickbackProjectState {
  //reports: ProjectReport[];
  invoiceReport:InvoiceFields[]
  reports: any;
  loading: boolean;
  contractConfirmation: CheckBox;
  showHelp: boolean;
  saving: boolean;
  statusObj:StatusObj;
  comment:string;
  
}
class SubmitKickbackProject extends React.Component<
  SubmitKickbackProjectProps,
  SubmitKickbackProjectState
> {
  invoiceColumns: ListColumn<InvoiceFields>[] = [
    {
      fieldName: "customer",
      isActive: true,
      key: "customer",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.customerName"),
      onRender(item, col) {
        return item.customer.value;
      },
    },
    {
      fieldName: "customerOrgId",
      isActive: true,
      key: "customerOrgId",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.customerOrgId"),
      onRender(item, col) {
        return item.customerOrgId.value;
      },
    },
    {
      fieldName: "contractId",
      isActive: true,
      key: "contractId",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.contractId"),
      onRender(item, col) {
        return item.contractId.value;
      },
    },
    {
      fieldName: "invoiceNumber",
      isActive: true,
      key: "invoiceNumber",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.invoiceLabel"),
      onRender(item, col) {
        return item.invoiceNumber.value;
      },
    },
    {
      fieldName: "billingDate",
      isActive: true,
      key: "billingDate",
      minWidth: 40,
      maxWidth: 120,
      name: `${i18n.t("kickbackProject.billingDate")}`,
      onRender(item, col) {
        return item.billingDate.value;
      },
    },
    {
      fieldName: "sumExclMoms",
      isActive: true,
      key: "sumExclMoms",
      minWidth: 40,
      maxWidth: 120,
      name: "sumExclMoms",
      onRender(item, col) {
        return item.rowSumExclMoms.value;
      },
    },
  ];
  columns: ListColumn<ProjectReport>[] = [
    {
      fieldName: "projectName",
      isActive: true,
      key: "projectName",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.projectName"),
    },
    {
      fieldName: "invoiceReference",
      isActive: true,
      key: "invoiceReference",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.invoiceReference"),
    },
    {
      fieldName: "invoiceIdentifier",
      isActive: true,
      key: "invoiceIdentifier",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.invoiceLabel"),
    },

    {
      fieldName: "comment",
      isActive: true,
      key: "comment",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.comment"),
    },
    {
      fieldName: "sumExclMoms",
      key: "sumExclMoms",
      minWidth: 40,
      maxWidth: 120,
      isActive: true,
      name: `${i18n.t("kickbackProject.sum")}`,
    },
    {
      fieldName: "kickbackSum",
      isActive: true,
      key: "kickbackSum",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t("kickbackProject.kickBackToBill"),
    },

    {
      fieldName: "projectEndDate",
      isActive: true,
      key: "projectEndDate",
      minWidth: 40,
      maxWidth: 120,
      name: i18n.t(
        "kickbackProject.endDate"
      ) /*this.props.t("invoiceReportList.reportDate").toString()*/,
      onRender(item, col) {
        // const date = new Date()
        return item.projectEndDate == null
          ? ""
          : new Date(item.projectEndDate).toLocaleDateString();
      },
    },
  ];
  constructor(props: SubmitKickbackProjectProps) {
    super(props);
    this.state = {
      reports: [],
      loading: true,
      contractConfirmation: {},
      showHelp: true,
      saving: false,
      invoiceReport: [],
      statusObj: {} as StatusObj,
      comment: "",
    };
  }

  componentDidMount(): void {
    this.parseStructureAndCalculate();
    document.addEventListener("mousedown", this.HandleClickOutside);
  }

  componentWillUnmount(): void {
    document.removeEventListener("mousedown", this.HandleClickOutside);
  }
  private myRef: any = React.createRef();
  private innerMenuRef: any = React.createRef();
  HandleClickOutside = (e: any) => {
    // if (!this.myRef.current.contains(e.target)) {
    //   this.setState({ showHelp: false });
    // }
  };
  HandleClickInside = (e: any) => {
    if (!this.myRef.current.contains(e.target)) {
      this.setState({ showHelp: false });
    }
  };
  private handleCheckBox = (contractId: string): void => {
    let update = JSON.parse(JSON.stringify(this.state.contractConfirmation));
    update[contractId] = !update[contractId];
    this.setState({ contractConfirmation: update });
  };
  private parseInvoiceReport = (): void => {
    const res: InvoiceFields[] = [];
    let statusObj: StatusObj = {
      warnings: 0,
      errors: 0,
      duplicates: 0,
      totalSum: 0,
      totalRows: 0,
      comment: "",
    };
    this.props.data[this.props.period].forEach((x, index) => {
      const invoice: InvoiceFields = {
        id: index,
        groupId: 0,
        billingDate: { value: x.billingDate } as FieldProperty,
        contractId: { value: x.contractId } as FieldProperty,
        customer: { value: x.customerName } as FieldProperty,
        customerOrgId: { value: x.customerOrgId } as FieldProperty,
        invoiceNumber: { value: x.invoiceNumber } as FieldProperty,
        rowSumExclMoms: {
          key: "",
          validation: "Good",
          format: "",
          message: "",
          type: "Number",
          value: x.totalExclMoms.value.toString(),
        },
        articleQuantity: { value: "" } as FieldProperty,
        articlePricePerUnit: { value: "" } as FieldProperty,
        articleNumber: { value: "" } as FieldProperty,
        articleText: { value: "" } as FieldProperty,
        articleQuantityType: { value: "" } as FieldProperty
      };
      let totalErrors = this.countEmptyValues(x);

      if (totalErrors > 0) {
        statusObj.errors = totalErrors + statusObj.errors;
      }
      if(x.projectEndDate.length == 0)
        statusObj.warnings++;
      if(x.reference.length == 0)
        statusObj.warnings++;
      if(x.tag.length == 0)
        statusObj.warnings++;
      if (x.isDuplicate.value) {
        statusObj.duplicates++;
      }
      if (!isNaN(x.totalExclMoms.value)) {
        statusObj.totalSum = x.totalExclMoms.value + statusObj.totalSum;
      }

      res.push(invoice);
    });

    statusObj.totalRows = res.length;
    this.setState({ invoiceReport: res, statusObj });
  };
  private countEmptyValues = (val: ProjectInvoice): number => {
    const keys: string[] = [
      "billingDate",
      "contractId",
      "customerName",
      "customerOrgId",
      "invoiceNumber",
      "totalExclMoms",
      "projectName"
    ];
    let errors = 0;
    Object.entries(val).forEach(([key, value]) => {
      if (key == "totalExclMoms") {
        if (val[key].display.length == 0 || val [key].valid == false) {
          errors++;
        }
      } 
      else if (keys.includes(key)) {
        let buff = value as string;
        if (buff.length == 0) {
          errors++;
        }
      }
    });
    return errors;
  };
  private parseStructureAndCalculate = (): void => {
    const projectKickbacks: { [contractId: string]: ProjectReport[] } = {};
    this.parseInvoiceReport();
    if (this.props.data[this.props.period].length !== 0) {
      const bufferObjToSumIdenticalRows: { [key: string]: ProjectReport } = {};
      this.props.data[this.props.period].reduce(
        (
          prev: { [contractId: string]: ProjectReport[] },
          item: ProjectInvoice
        ) => {
          const key = `${item.contractId}-${item.projectName}-${item.reference}-${item.tag}`;
          if (item.contractId.length > 0) {
            if (!prev[item.contractId]) {
              const arr: ProjectReport[] = [];
              prev[item.contractId] = arr;
            }
            let kickbackValue = (item.totalExclMoms.value * item.kick).toFixed(
              2
            );
            if (bufferObjToSumIdenticalRows[key]) {
              bufferObjToSumIdenticalRows[key].kickbackSum += +kickbackValue;
              bufferObjToSumIdenticalRows[key].sumExclMoms +=
                item.totalExclMoms.value;
            } else {
              const date = new Date();
              const endDate = this.checkDate(item.projectEndDate);
              const buff = {
                id: item.uniqueRowId,
                reportId: "",
                contractId: item.contractId,
                projectName: item.projectName,
                invoiceReference: item.reference,
                invoiceIdentifier: item.tag,
                kickbackSum: +kickbackValue,
                sumExclMoms: item.totalExclMoms.value,
                comment: item.comment,
                period: this.props.period,
                reportDate: date,
                reporter: "",
                supplierOrgId: item.supplierOrgId,
                projectEndDate: endDate,
                status: 1,
                customerId: item.customerId,
              } as ProjectReport;
              bufferObjToSumIdenticalRows[key] = buff;
            }
          }

          return prev;
        },
        projectKickbacks
      );
      Object.values(bufferObjToSumIdenticalRows).forEach((x: ProjectReport) => {
        projectKickbacks[x.contractId].push(x);
      });
      this.setState({ reports: projectKickbacks }, () => this.initCheckBoxes());
    }
  };

  private initCheckBoxes = (): void => {
    const checkBoxKeys = Object.keys(this.state.reports);
    let checkBoxObj: CheckBox = {};
    checkBoxKeys.reduce((acc: CheckBox, item) => {
      if (!checkBoxObj[item]) {
        checkBoxObj[item] = false;
      }
      return checkBoxObj;
    }, checkBoxObj);
    checkBoxObj[`${i18n.t("kickbackProject.invoiceReport")}`] = false;
    this.setState({ contractConfirmation: checkBoxObj }, () =>
      this.setState({ loading: false })
    );
  };
  private checkBoxMenu = (contractId: string): JSX.Element => {
    return (
      <>
        <div
          className="checkYeah"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <Form.Check
            style={{ marginLeft: 5 }}
            type="checkbox"
            onChange={(e) => this.handleCheckBox(contractId)}
            checked={this.state.contractConfirmation[contractId]}
          />
          <p className="checkBoxText">
            {i18n.t("kickbackProject.confirmButton")}
          </p>
        </div>
      </>
    );
  };

  private checkDate = (date: string): Date | null => {
    return typeof date == "undefined"
      ? null
      : date.length > 0
      ? new Date(date)
      : null;
  };
  private renderInvoiceReport = (): JSX.Element => {
    if (typeof this.state.invoiceReport !== "undefined") {
      return (
        <StyledAccordion
          alwaysOpen={true}
          title={
            <>
              {i18n.t("kickbackProject.invoiceReport")}{" "}
              {this.state.contractConfirmation[
                `${i18n.t("kickbackProject.invoiceReport")}`
              ] == true ? (
                <FontAwesomeIcon
                  style={{ color: "rgb(146, 192, 31)" }}
                  icon="check-circle"
                />
              ) : (
                <FontAwesomeIcon
                  style={{ color: "rgba(179, 4, 4, 0.8)" }}
                  icon="circle-xmark"
                />
              )}
            </>
          }
          style={{
            marginTop: "25px",
            borderTop: "5px solid var(--statistic-color)",
          }}
        >
          <Stack
            gap={3}
            style={{
              maxHeight: "700px",
              overflowY: "scroll",
              overflowX: "hidden",
              padding: "0px 10px",
              marginBottom: "12px"
            }}
          >
            <div style={{marginLeft: "-5px"}}>
              {this.checkBoxMenu(i18n.t("kickbackProject.invoiceReport"))}
            </div>
            <Row className="gy-3">
              <Col xs={12} md={6} lg={4} >
                {this.renderDataCard(i18n.t("kickbackProject.warning"), this.state.statusObj.warnings.toString(), "triangle-exclamation","rgb(245, 156, 47,0.8)", () => { this.props.onClickDataCard("warnings"); } )}
              </Col>
              <Col xs={12} md={6} lg={4} >
                {this.renderDataCard(i18n.t("kickbackProject.errors"), this.state.statusObj.errors.toString(), "circle-exclamation","rgb(179, 4, 4, 0.8)", () => { this.props.onClickDataCard("errors"); } )}
              </Col>
              <Col xs={12} md={6} lg={4} >
                {this.renderDataCard(i18n.t("kickbackProject.duplicates"), this.state.statusObj.duplicates.toString(), "copy","rgb(11, 93, 151,0.8)", () => { this.props.onClickDataCard("duplicates"); } )}
              </Col>
              <Col xs={12} md={6} lg={6} >
                {this.renderDataCard(i18n.t("kickbackProject.totalRows"), this.state.statusObj.totalRows.toString(), "list","rgba(86, 89, 89, 0.95)" )}
              </Col>
              <Col xs={12} d={12} lg={6} >
                {this.renderDataCard(i18n.t("kickbackProject.total"), ReadFriendlyNumber(this.state.statusObj.totalSum), "sack-dollar","rgb(86, 181, 58,0.8)" )}
              </Col>
            </Row>
            <FormGroup>
              <Form.Label>{i18n.t("kickbackProject.cleanComment")}</Form.Label>
              <Form.Control 
                type="text" 
                as="textarea"
                onChange={(value) =>
                  this.setState((prevState) => ({
                    ...prevState,
                    statusObj: {
                      ...prevState.statusObj,
                      comment: value.target.value,
                    },
                  }))
                }
                autoCorrect="off"
                spellCheck="false"
              />
            </FormGroup>
          </Stack>
        </StyledAccordion>
      );
    } else {
      return <></>;
    }
  };
  private totalBilling = (key: string): JSX.Element => {
    const sum: string = this.state.reports[key]
      .reduce((acc: number, item: any) => {
        return acc + item.kickbackSum;
      }, 0)
      .toFixed(2);
    return (
      <>
        <span>
          <i>{i18n.t("kickbackProject.Total")}</i>
          <i> </i>
          <b style={{ marginLeft: 4 }}>{sum}</b>
        </span>
      </>
    );
  };
  private renderTable = (): JSX.Element[] => {
    const tableElements: JSX.Element[] = [];
    Object.keys(this.state.reports).forEach((w) =>
      tableElements.push(
        <div style={{ marginBottom: 15, marginTop: 15 }}>
          <StyledAccordion
            alwaysOpen={true}
            title={`${i18n.t("kickbackProject.contract")} ${w} `}
          >
            <>
              <div
                style={{ display: "flex", flexWrap: "wrap", marginRight: "4%" }}
              >
                {this.checkBoxMenu(w)}
              </div>

              <div style={{ maxHeight: "60vh" }}>
                <Datalist
                  isLoading={this.state.loading}
                  uniqueKey="contractId"
                  items={this.state.reports[w]}
                  columns={this.columns}
                  noItemsText={i18n.t("kickback.table.empty")}
                  initialSortKey="contractId"
                  setColumns={(cols) => {}}
                />
              </div>
              <Stack
                style={{ marginTop: 5, marginBottom: 5 }}
                direction="horizontal"
              >
                {this.totalBilling(w)}
              </Stack>
            </>
          </StyledAccordion>
        </div>
      )
    );
    return tableElements;
  };
  
  private handleSubmit = async (): Promise<void> => {
    this.setState({ saving: true });
    const keys = Object.keys(this.state.reports);
    const polishedProjectReports: ProjectReport[] = [];
    for (let index = 0; index < keys.length; index++) {
      const element: ProjectReport[] = this.state.reports[keys[index]];
      element.forEach((e: ProjectReport) => {
        polishedProjectReports.push(e);
      });
    }

    const res: any = await DataService.Kickback.PostProjectReport(
      polishedProjectReports,
      this.state.invoiceReport,
      this.state.statusObj,
      i18n.language
    );

    if (res.Content.parsedRes.statusCode == 200) {
      this.setState({ saving: false });
      let apitranslatedMessage = `${i18n.t("kickbackProject.apiSuccess")}`;
      this.props.submitHandler(
        this.props.period,
        res.Content.parsedRes.statusCode,
        apitranslatedMessage
      );
    } else if (res.Content.parsedRes.statusCode == 304) {
      this.setState({ saving: false });
      let rows = res.Content.parsedRes.message.split(",");
      let apiErrorMessage = `${i18n.t("kickbackProject.apiError")} ${
        rows[0]
      } ${i18n.t("kickbackProject.off")}  ${rows[1]} ${i18n.t(
        "kickbackProject.row"
      )}`;
      this.props.submitHandler(
        this.props.period,
        res.Content.parsedRes.statusCode,
        apiErrorMessage
      );
    } else {
      this.setState({ saving: false });
      this.props.submitHandler(
        this.props.period,
        res.Content.parsedRes.statusCode,
        res.Content.parsedRes.message,
        JSON.stringify(res.Content.parsedRes.duplicates)
      );
    }
  };
  private handleHelpToggle = (): void => {
    this.setState((prevState) => ({ showHelp: !prevState.showHelp }));
  };
  private renderDataCard = (title:string, number: string, icon: IconProp, color: string, onClick?:Function) => {
    const shouldOnClick = onClick// && number > "0";
    const classNames = !shouldOnClick ? "submit-kickback-project-datacard"
      : "submit-kickback-project-datacard submit-kickback-project-datacard-clickable"
    
    return <Stack
        className={classNames}
        direction="horizontal"
        onClick={() => { if(shouldOnClick) onClick(); }}
        gap={2}
        style={{
          borderLeft: "5px solid "+color,
          position: "relative"
        }}
    >
      <FontAwesomeIcon
        style={{ color: color, fontSize: "2rem" }}
        icon={icon}
      />
      <div>
        <span className="value" style={{ color: color, fontSize: "1.3rem", marginRight: 8 }}>
          {number}
        </span>
        <span className="textTitle" style={{fontSize: "1.2rem"}}>{title}</span>
      </div>
      {
        shouldOnClick &&
        <div>
          <FontAwesomeIcon icon={"square-up-right"} style={{ color: "#8786867a", position: "absolute", right:6, top: 6, fontSize: "1.3rem" }}/>
        </div>
      }
    </Stack>
  }

  private renderInfoCard = (): JSX.Element => {
    return (
      <>
        <div
          ref={this.myRef}
          //onClick={() => this.handleHelpToggle()}
          className="submitModalInfoCardContainer"
        >
          <FontAwesomeIcon className="infoIcon" icon="info-circle" />

          <div
            ref={this.innerMenuRef}
            style={this.state.showHelp ? { maxHeight: 500 } : { maxHeight: 0 }}
            onClick={this.HandleClickInside}
            className="submitModalInfoCardContentActive"
            // className={this.state.showHelp ? 'submitModalInfoCardContentActive': 'submitModalInfoCardContentInActive'}
          >
            <p className="paragraph">
              <li className="infoLielement">
                {i18n.t("kickbackProject.confirm")}
              </li>
              <li className="infoLielement">
                {i18n.t("kickbackProject.RowsIdentical")}
              </li>
              <li className="infoLielement">
                {i18n.t("kickbackProject.errorsDuplicates")}
              </li>
              <li className="infoLielement">
                {i18n.t("kickbackProject.confirmInfo")}
              </li>
            </p>
          </div>
        </div>
      </>
    );
  };
  render() {
    let disableSendButton =
      typeof Object.values(this.state.contractConfirmation)
        .find((x) => x !== true)
        ?.valueOf() !== "undefined" ||
      this.state.statusObj.errors > 0 ||
      this.state.statusObj.duplicates > 0;

    let alContractsValid = Object.entries(this.state.contractConfirmation)
      .filter((x) => {
        if (x[0] !== "Statistik-rapport") {
          return x[1] !== true;
        }
      })
      .find(([x, q]) => q !== true)?.[1]
      .valueOf();
    return (
      <div>
        <StyledModal
          className="full-width"
          title={`${i18n.t("kickbackProject.review")}`}
          onDismiss={this.props.closeModal}
          body={
            <>
              {this.state.loading && <Spinner />}

              {!this.state.loading && (
                <div>
                  {this.renderInfoCard()}
                  <p style={{ fontSize: "18px" }}>
                    {" "}
                    {`${i18n.t("kickbackProject.report")}` +
                      " period " +
                      this.props.period[0].toUpperCase()}
                    {this.props.period.substring(1, this.props.period.length)}
                  </p>
                  <div>{this.renderInvoiceReport()}</div>

                  <StyledAccordion
                    alwaysOpen={true}
                    title={
                      <>
                        {i18n.t("kickbackProject.projectReport")}{" "}
                        {typeof alContractsValid == "undefined" ? (
                          <FontAwesomeIcon
                            style={{
                              marginLeft: "8px",
                              color: "rgb(146, 192, 31)",
                            }}
                            icon="check-circle"
                          />
                        ) : (
                          <FontAwesomeIcon
                            style={{
                              marginLeft: "8px",
                              color: "rgba(179, 4, 4, 0.8)",
                            }}
                            icon="circle-xmark"
                          />
                        )}
                      </>
                    }
                    style={{
                      marginTop: "25px",
                      borderTop: "5px solid rgb(86, 181, 58)",
                    }}
                  >
                    <>{this.renderTable()}</>
                  </StyledAccordion>
                </div>
              )}
            </>
          }
          footer={
            <Stack direction="horizontal" gap={2}>
              <Button
                disabled={disableSendButton || IsUserSinfra()}
                className="button button-submit"
                onClick={() => this.handleSubmit()}
              >
                {this.state.saving ? (
                  <Spinner animation="border" size={"sm"} />
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faPaperPlane}
                      style={{ marginRight: 4 }}
                    />
                    {t("general.send")}
                  </>
                )}
              </Button>
            </Stack>
          }
        />
      </div>
    );
  }
}
export default withTranslation()(SubmitKickbackProject);
